import cn from 'classnames';
import { ErrorBoundary } from 'react-error-boundary';
import { useSuspenseRouteName } from '#api/routes.queries.ts';
import { Link } from '#components/atoms/link/Link.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { makeFallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';

type Props = { routeId: `route-${string}`; className?: string };

/**
 * Renders a link to a route detail page, fetching its name to show
 */
export function RouteLink(props: Props) {
  return (
    <ErrorBoundary
      fallbackRender={makeFallbackRenderNotFound(
        <>
          Route <span className="truncate">{props.routeId}</span> not found
        </>
      )}
    >
      <InnerRouteLink {...props} />
    </ErrorBoundary>
  );
}

function InnerRouteLink({ routeId, className }: Props) {
  const location = useAppLocation();
  const routeName = useSuspenseRouteName(routeId);

  return (
    <Link to={`/routes/${routeId}`} state={{ from: location }} className={cn('a', className)}>
      {routeName}
    </Link>
  );
}
